import { render, staticRenderFns } from "./details-toggle.vue?vue&type=template&id=1a16f3d0&scoped=true&"
import script from "./details-toggle.vue?vue&type=script&lang=ts&"
export * from "./details-toggle.vue?vue&type=script&lang=ts&"
import style0 from "./details-toggle.vue?vue&type=style&index=0&id=1a16f3d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a16f3d0",
  null
  
)

export default component.exports